import React, {
  useState,
  useEffect,
}                           from 'react';
import { historyPropType }  from '~/config/routerPropTypes';
import { showFile }         from '~/config/routes';
import Request              from '~/providers/Request';
import FileRecord           from '~/records/FileRecord';
import Form                 from './Form';
import isPresent            from '~/utils/isPresent';
import { URL }              from '~/config/uri';

function EditRecord({history}){
  const [ record, setRecord] = useState(new FileRecord());
  const [ loading, setLoading] = useState(false);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id){
      setLoading(true);
      Request.get(`/admin/files/${id}`, {})
        .then( response => {
          setLoading(false);
          setRecord( record.updateAttributes(response.data) );
        })
        .catch( e => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  async function onSubmit (){
    setLoading(true);
    const { data }  = record.toParams();
    const files = data.attributes.files;
    if(isPresent(files)) {
      const formData = new FormData();
      formData.append('file[]', files[0]);
      fetch(`${URL}/admin/files/upload?id=${id}`, {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${await Request.getAuth()}` },
      }).then(() => {
        updateRecord({ data });
       })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
    } else { updateRecord({ data }); }
  }

  const updateRecord = ({ data }) => {
    Request.put(`/admin/files/${id}`, { data }, {}, { controller: 'files' })
    .then((resp) => {
      setLoading(false);
      history.push(showFile.reverse(resp.data));
    }).catch((e) => {
      console.error(e);
      setLoading(false);
    });
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

EditRecord.propTypes={
  history: historyPropType,
};

export default EditRecord;
